import clsx from "clsx";
import React from "react";

interface CustomHTMLProps extends React.HTMLProps<HTMLInputElement> {
  icon: React.ReactNode;
  containerClassName?: string;
}
type MergedProps = React.HTMLProps<HTMLElement> & CustomHTMLProps;
const InputWithStartIcon: React.FC<MergedProps> = ({ icon, containerClassName, ...props }) => {
  return (
    <div className={clsx(containerClassName)}>
      <div className="relative mt-2 rounded-md shadow-sm">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">{icon}</div>
        <input
          {...props}
          className="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />
      </div>
    </div>
  );
};

export default InputWithStartIcon;
